export function resolveAddFoodModalSaveResult({
  result,
  trackedFood = null,
  fallbackFood = null,
}) {
  const resolvedFood = trackedFood ?? result?.result ?? fallbackFood ?? null;

  if (result?.ok === true) {
    return {
      savedFood: resolvedFood,
      shouldShowOfflinePendingToast: false,
    };
  }

  if (result?.kind === "offline_pending") {
    return {
      savedFood: resolvedFood,
      shouldShowOfflinePendingToast: true,
    };
  }

  return {
    savedFood: null,
    shouldShowOfflinePendingToast: false,
  };
}
